// class for timeouts with play and pause functionality
class TimeoutService {
  constructor(delay, callback){
    this.set(delay, callback);
  }
  pause (){
    clearTimeout(this.timerId);
    this.remaining -= new Date() - this.start;
  }
  play (){
    this.start = new Date();
    clearTimeout(this.timerId);
    this.timerId = setTimeout(this.callback, this.remaining);
  }
  set(delay, callback){
   this.timerId = this.start = this.remaining = delay;
   this.callback = callback;
  }
  clear(){
    clearTimeout(this.timerId);
    this.timerId = this.start = this.remaining = this.callback = null;
  }
}

module.exports = TimeoutService;